import { Component } from '@angular/core';

@Component({
  selector: 'uni-widget',
  templateUrl: './uni-widget.component.html',
  styleUrls: ['./uni-widget.component.scss'],
})
export class UniWidgetComponent {
}
